<template>
    <t-form>
        <e-collapse title="基础配置" :expand="false">
            <!-- <component is="cpt-dataV-border-option" :attribute="currentCpt.cptOption.attribute"
                :cptDataForm="currentCpt.cptOption.cptDataForm" :refMap="refMap" :currentCpt="currentCpt" /> -->
            <t-form-item label="背景颜色">
                <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.backgroundColor"
                    enableAlpha />
            </t-form-item>
            <t-form-item label="边框颜色">
                <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.borderColor"
                    enableAlpha />
            </t-form-item>
            <t-form-item label="边框宽度">
                <t-input-number size="small" v-model="attribute.borderSize" :min="0" :max="9999" :decimal-places="0" />
            </t-form-item>
            <t-form-item label="圆角">
                <t-input-number size="small" v-model="attribute.borderRadius" :min="0" :max="9999" :decimal-places="0" />
        </t-form-item>
            <t-form-item label="悬浮位置">
                <t-select v-model="attribute.position" size="small">
                    <t-option label="任意位置" value="all" />
                    <t-option label="顶部" value="top" />
                    <t-option label="底部" value="bottom" />
                    <t-option label="左侧" value="left" />
                    <t-option label="右侧" value="right" />
                </t-select>
            </t-form-item>
            <t-form-item label="悬浮X轴">
                <t-input-number size="small" v-model="attribute.postitionX" :min="0" :max="999999" :decimal-places="0" />
            </t-form-item>
            <t-form-item label="悬浮Y轴">
                <t-input-number size="small" v-model="attribute.postitionY" :min="0" :max="999999" :decimal-places="0" />
            </t-form-item>
        </e-collapse>
    </t-form>
</template>

<script>
//   name: "cpt-dataV-border-option",
//   props: { attribute: Object,currentCpt: Object , refMap: Object},
export default {
    name: 'cpt-suspension',
    components: {

    },
    props: {
        attribute: Object, currentCpt: Object, refMap: Object
    },
    data() {
        return {
        }
    },
    mounted() {
        console.log(this.current, 'cptOptionKey')
    }

}
</script>